// extracted by mini-css-extract-plugin
export default {"quarter-btn":"quarter-btn--sbkHALBV7q","quarterBtn":"quarter-btn--sbkHALBV7q","comment-btn":"comment-btn--bDxV7Gn0FE","commentBtn":"comment-btn--bDxV7Gn0FE"};